// Types
import { APP_NAMES } from "../types/app";
import { getAppName } from "../utils/common";

type CaptchaKeys = Record<string, string>;

const launchDarklyKeys: Record<string, CaptchaKeys> = {
  [APP_NAMES.RRA]: {
    staging: '692937339837460b00d3ecf7',
    testing: '692935c03e135e0b05c633a5',
    preprod: '692941cb45ff030ad9f391a5',
    prod: '692935c03e135e0b05c633a6',
  },
  [APP_NAMES.ESP]: {
    prod: '69961a2cd738ba09f2eca41b',
    staging: '699745783248fb09e15842fc',
    main: '6997454d76538409bd19d6e9',
    preprod: '6997455e552ff209fda825c5',
    qa: '6997456641410309fc2cd7b3',
  },
};

export const getLaunchDarklyKey = (): string => {
  const appName = getAppName();
  const env: string = process.env.REACT_APP_DEPLOY_ENV || process.env.DEPLOY_ENV || 'prod';

  return launchDarklyKeys[appName][env] ?? 'undefined';
};
